<template>
  <div class="team-building">
    <div class="team-building-hero flex flex-col items-center justify-center">
      <img src="https://images.ctfassets.net/3dar4x4x74wk/3rZE0MN5SYMQONPs9mBBRP/2b47469ac4db1fc094aa43636aa5b3c0/Logo_team-building-main.png" alt="Team Building Logo">
      <h1 class="font-decimal text-white">share the fun. share the glory. build a better team.</h1>
    </div>
    <div class="team-building-packages">
      <div class="team-building-wrapper max-w-6xl mx-auto">
        <img class="w-full md:w-1/2 mx-auto" src="https://images.ctfassets.net/3dar4x4x74wk/589i34xUkzd8vAmSeIcZw3/b69ebfb32c177eed5e565acb05619081/ME_TB_Web_header_only__2_.svg" alt="No one has ever said, “I want to thank myself” in a victory speech.">
        <h2 class="font-decimal text-white max-w-2xl mx-auto text-center">Connect. Collab. Build something awesome together with our all new Team Building packages.</h2>
        <h3 class="font-decimal text-white uppercase max-w-4xl mx-auto text-center">Which Team Building package is perfect for your team?</h3>
        <div class="packages w-full flex flex-col md:flex-row items-center md:items-start justify-center md:justify-between pt-8 sm:pt-0">
          <div class="package flex flex-col items-center justify-center">
            <video
              poster="https://images.ctfassets.net/3dar4x4x74wk/53uVxME289aHOs60LQazL1/98d4e9a71976d8c54df1ebd92702a01a/Relay_Still1__1_.png" 
              :width="mobile ? '100%' : '80%'"
              height="auto"
              controls="controls" >
              <source src="https://videos.ctfassets.net/3dar4x4x74wk/31Y5UqPpm5syu4prYwpyY8/0f013d089f82f3d9c6b2b9d968298f28/Relay_Rush_Final.mp4" type="video/mp4">
            </video>
            <img src="https://images.ctfassets.net/3dar4x4x74wk/K5OIcawZ2REuF8JTfNIqA/24d8c72338c439806b5c1fdb84cbdda1/Lockup_relay-rush.png" alt="Relay Rush">
            <h4 class="font-decimal text-white uppercase text-center">Games | Action  | Friendly Competition</h4>
            <p class="font-decimal text-white text-center">Enhance your team’s communication skills with 3 fast-paced video game levels of increasing difficulty. Teams will work together in a relay through the video game area.</p>
            <h4 class="font-decimal text-white uppercase text-center">3-4 Players per Team</h4>
          </div>
          <div class="package flex flex-col items-center justify-center">
            <video
              poster="https://images.ctfassets.net/3dar4x4x74wk/7CDy4S37zLtZS0nYPI8Rza/755a6a08c07d8f71ac18a96052e5833b/Collab_Still2__1_.png" 
              :width="mobile ? '100%' : '80%'"
              height="auto"
              controls="controls" >
              <source src="https://videos.ctfassets.net/3dar4x4x74wk/4YqxIWR3QKtOmU1POWCXF0/e39cbcafe2b82f66ad3883514d1a9919/Collab_For_A_Cause_Final.mp4" type="video/mp4">
            </video>
            <img src="https://images.ctfassets.net/3dar4x4x74wk/6yetS8ghMycRDDR40kzYtQ/c07a69a65ed3690dc63bdd3dbfdee3b1/Lockup_collab-4-a-cause.png" alt="Collab 4 A Cause">
            <h4 class="font-decimal text-white uppercase text-center">Brain Teasers | Strategy | Giving Back </h4>
            <p class="font-decimal text-white text-center">Build your team’s skills with interactive word puzzles, riddles, trivia and video game play competitions culminating by building care packages and backpacks for your local community or favorite organization.</p>
            <h4 class="font-decimal text-white uppercase text-center">10-15 Players per Team</h4>
          </div>
        </div>
      </div>
    </div>
    <div class="package-overviews">
      <div class="team-building-wrapper max-w-6xl mx-auto">
        <h2 class="font-pie uppercase">All Packages</h2>
        <div class="packages flex flex-col md:flex-row items-start justify-center md:justify-between">
          <div class="package">
            <img src="https://images.ctfassets.net/3dar4x4x74wk/26WgNBot3sMXyuvX1cbI6T/baf60ab3b0653849800ebe76fd5bd4e1/Icon_controller-gradient.png" alt="Relay Rush Controller Icon">
            <div class="subtitle flex items-center">
              <p class="font-decimal uppercase text-tb-turqoise font-bold">Competition</p>
              <div class="bg-tb-turqoise"/>
            </div>
            <h1 class="font-pie uppercase mb-2 text-tb-turqoise">Relay<br/>Rush</h1>
            <h4 class="font-decimal font-black text-sm text-tb-turqoise mt-6 mb-2">3-4 Players <span class="font-decimal uppercase text-tb-turqoise text-xs font-bold">/ Team</span></h4>
            <p class="font-decimal text-tb-turqoise text-sm font-bold mb-4">Enhance your team’s communication &amp; problem-solving skills with 3 fast paced video game levels that increase in difficulty with each victory. Teams will work together in a relay style race through our video game area. </p>
            <p class="font-decimal text-tb-turqoise text-sm font-bold mb-4"><b>Skills:</b> Collaboration, Communication &amp; Problem Solving </p>
            <h3 class="uppercase font-decimal text-tb-turqoise text-xl font-black mb-2">What's Included</h3>
            <p class="font-decimal border-b-2 text-tb-turqoise text-sm border-tb-turqoise pb-2 mb-2">Up to 2 Hours</p>
            <p class="font-decimal border-b-2 text-tb-turqoise text-sm border-tb-turqoise pb-2 mb-2">Four Refereed Team Competitions:<br/>NBA Hoops, Air Hockey, *Mario Kart, SkeeBall</p>
            <p class="font-decimal border-b-2 text-tb-turqoise text-sm border-tb-turqoise pb-2 mb-2">Private Room (Up to 1 Hour)</p>
            <p class="font-decimal border-b-2 text-tb-turqoise text-sm border-tb-turqoise pb-2 mb-2">Time Cards for Games &amp; Challenges </p>
            <p class="font-decimal border-b-2 text-tb-turqoise text-sm border-tb-turqoise pb-2 mb-4">Team Gear - Headband, Under Eye Stickers</p>
            <p class="font-decimal border-b-2 text-tb-turqoise text-sm border-tb-turqoise pb-2 mb-2">FUN-cilitator Host</p>
            <p class="font-decimal border-b-4 text-tb-turqoise text-sm border-tb-turqoise pb-2 mb-2">Awards</p>
            <span class="font-decimal text-tb-turqoise text-xs leading-none italic"><b>Add Ons: </b>Ask your sales manager how to enhance your experience by adding VR, additional activities and food and beverage packages to your event.</span>
           <h1 class="price font-pie text-tb-turqoise mt-6 mb-2"><sup>$</sup>19<sup>95</sup>  <span class="font-decimal uppercase text-tb-turqoise text-sm font-bold">/ Person</span></h1>
           <p class="font-decimal text-tb-turqoise text-xs">12 Guest Minimum</p>
          </div>
          <div class="package">
            <img src="https://images.ctfassets.net/3dar4x4x74wk/6lYssX9wUGxnwkQvE4wEsV/67d20bb64ef833e0f560d3ed094a1694/Icon_backpack-gradient.png" alt="Collab 4 A Cause Backpack Icon">
            <div class="subtitle flex items-center">
              <p class="font-decimal uppercase text-tb-pink font-bold">Give Back</p>
              <div class="bg-tb-pink"/>
            </div>
            <h1 class="font-pie uppercase mb-2 text-tb-pink">Collab<br/>For A Cause</h1>
            <h4 class="font-decimal font-black text-sm text-tb-pink mt-6 mb-2">10-15 Players <span class="font-decimal uppercase text-tb-pink text-xs font-bold">/ Team</span></h4>
            <p class="font-decimal text-tb-pink text-sm font-bold mb-4">Build your team’s skills with interactive word puzzles, riddles, trivia and video game play competitions culminating by building care packages or  backpacks for your favorite organization.</p>
            <p class="font-decimal text-tb-pink text-sm font-bold mb-4"><b>Skills:</b> Rapport, Communication, Active Listening &amp; Strategy</p>
            <h3 class="uppercase font-decimal text-tb-pink text-xl font-black mb-2">What's Included</h3>
            <p class="font-decimal border-b-2 text-tb-pink text-sm border-tb-pink pb-2 mb-2">Up to 3 Hours</p>
            <p class="font-decimal border-b-2 text-tb-pink text-sm border-tb-pink pb-2 mb-2">Team Table Challenges (Brain Teasers)</p>
            <p class="font-decimal border-b-2 text-tb-pink text-sm border-tb-pink pb-2 mb-2">Connect 4 &amp; Arcade Attack</p>
            <p class="font-decimal border-b-2 text-tb-pink text-sm border-tb-pink pb-2 mb-2">Select which cause (school or military) to donate to</p>
            <p class="font-decimal border-b-2 text-tb-pink text-sm border-tb-pink pb-2 mb-2">Private Room (Up to 1 Hour)</p>
            <p class="font-decimal border-b-2 text-tb-pink text-sm border-tb-pink pb-2 mb-2">Supplies to pack (school backpack or hero box)</p>
            <p class="font-decimal border-b-2 text-tb-pink text-sm border-tb-pink pb-2 mb-2">15 Minute Time Card</p>
            <p class="font-decimal border-b-2 text-tb-pink text-sm border-tb-pink pb-2 mb-4">Team Gear - Headband, Under Eye Stickers</p>
            <p class="font-decimal border-b-2 text-tb-pink text-sm border-tb-pink pb-2 mb-4">FUN-cilitator Host</p>
            <p class="font-decimal border-b-4 text-tb-pink text-sm border-tb-pink pb-2 mb-4">Awards</p>
            <span class="font-decimal text-tb-pink text-xs leading-none italic"><b>Add Ons: </b>Ask your sales manager how to enhance your experience by adding VR, additional activities and food and beverage packages to your event.</span>
           <h1 class="price font-pie text-tb-pink mt-6 mb-2"><sup>$</sup>42<sup>95</sup>  <span class="font-decimal uppercase text-tb-pink text-sm font-bold">/ Person</span></h1>
           <p class="font-decimal text-tb-pink text-xs">12 Guest Minimum</p>
          </div>
          <div class="package">
            <img src="https://images.ctfassets.net/3dar4x4x74wk/45vIDsAu3aFjtX7xiqXKoO/ea9182728175bc8189d7c0132d26f09e/Icon_flag-gradient.png" alt="All-Star Adventure Flag Icon">
            <div class="subtitle flex items-center">
              <p class="font-decimal uppercase text-tb-purple font-bold">Collab</p>
              <div class="bg-tb-purple"/>
            </div>
            <h1 class="font-pie uppercase mb-4 text-tb-purple">All-Star<br/>Adventure</h1>
            <h4 class="font-decimal font-black text-sm text-tb-purple mt-6 mb-2">3-4 Players <span class="font-decimal uppercase text-tb-purple text-xs font-bold">/ Team</span></h4>
            <p class="font-decimal text-tb-purple text-sm font-bold mb-4">Work together to complete an Amazing Race-style competition through Main Event!</p>
            <p class="font-decimal text-tb-purple text-sm font-bold mb-4"><b>Skills:</b> Problem Solving, Teamwork &amp; Strategy</p>
            <h3 class="uppercase font-decimal text-tb-purple text-xl font-black mb-2">What's Included</h3>
            <p class="font-decimal border-b-2 text-tb-purple text-sm border-tb-purple pb-2 mb-2">Up To 3 Hours</p>
            <p class="font-decimal border-b-2 text-tb-purple text-sm border-tb-purple pb-2 mb-2">1 1/2 Hour Bowling</p>
            <p class="font-decimal border-b-2 text-tb-purple text-sm border-tb-purple pb-2 mb-2">Bowling Shoes</p>
            <p class="font-decimal border-b-2 text-tb-purple text-sm border-tb-purple pb-2 mb-2">Private Room (Up to 1 Hour)</p>
            <p class="font-decimal border-b-2 text-tb-purple text-sm border-tb-purple pb-2 mb-2">$25 Fun Card</p>
            <p class="font-decimal border-b-2 text-tb-purple text-sm border-tb-purple pb-2 mb-2">Team Gear - Headband, Under Eye Stickers</p>
            <p class="font-decimal border-b-2 text-tb-purple text-sm border-tb-purple pb-2 mb-2">FUN-cilitator Host</p>
            <p class="font-decimal border-b-4 text-tb-purple text-sm border-tb-purple pb-2 mb-4">Awards</p>
            <span class="font-decimal text-tb-purple text-xs leading-none italic"><b>Add Ons: </b>Ask your sales manager how to enhance your experience by adding VR, additional activities and food and beverage packages to your event.</span>
           <h1 class="price font-pie text-tb-purple mt-6 mb-2"><sup>$</sup>29<sup>95</sup>  <span class="font-decimal uppercase text-tb-purple text-sm font-bold">/ Person</span></h1>
           <p class="font-decimal text-tb-purple text-xs">12 Guest Minimum</p>
          </div>
        </div>
      </div>
    </div>
    <div class="team-building-form">
      <div class="team-building-wrapper max-w-6xl mx-auto">
        <ContactForm />
        <p class="disclaimer font-decimal text-black text-center">Booking Restrictions: Packages available for a minimum of 12 guests; ask how we can customize for smaller groups. Not valid with any other offer or coupon. Not valid from 5 pm Friday to 5 pm Sunday. Price does not include sales tax or 20% FUN-cilitator Host fee. Reservations required. 50% deposit required to confirm reservation. Fun Card valid for video game play only.</p>
      </div>
    </div>
    <div class="bottom-image" />
  </div>
</template>

<script>
import PageSections from '~/components/PageSections'
import ContactForm from '~/components/common/TeamBuildingContactForm'

export default {
  components: {
    PageSections,
    ContactForm
  },
  layout: 'team-building',
  async asyncData({ $api, params }) {
    return {
      page: await $api.getPage('events/teambuilding'),
    };
  },
  data() {
    return {
      page: {
        fields: {},
      },
    };
  },
  async validate({ $api, params }) {
    return await $api.getPage('events/teambuilding')
  },
  head() {
    return this.$metadata(this.page)
  },
  computed: {
    mobile() {
      if (this.$mq === 'sm') {
        return true
      } else {
        return false
      }
    },
  }
}
</script>

<style lang="scss">
@import '~/assets/scss/_variables';

.team-building {

  .team-building-hero {
    padding: 115px 30px 50px 30px;
    min-height: 300px;
    background-image: url('https://images.ctfassets.net/3dar4x4x74wk/l6QjLsRNFg8pOndhzqAaV/ec7ccf5f4248df9a5f962121fa2065d6/team-building-header.jpg');
    background-size: cover;
    background-position: top;
    transform: skewY(-4deg);
    margin-bottom: -50px;

    @media (min-width: 1170px) {
      padding: 167px 30px 50px 30px;
      min-height: 600px;
    }

    @media (min-width: 1400px) {
      transform: skewY(-3deg);
      min-height: 700px;
    }

    img {
      width: 50%;
      max-width: 300px;
      transform: skewY(4deg);
      filter: drop-shadow(2px 4px 5px rgba(0, 0, 0, .7));

      @media (min-width: 1170px) {
        width: 80%;
      }

      @media (min-width: 1400px) {
        transform: skewY(3deg);
      }
    }

    h1 {
      margin-top: 25px;
      text-transform: uppercase;
      text-align: center;
      font-size: 24px;
      font-weight: 900;
      transform: skewY(4deg);
      filter: drop-shadow(2px 4px 5px rgba(0, 0, 0, 1));

      @media (min-width: 1400px) {
        transform: skewY(3deg);
      }
    }
  }

  .team-building-packages {
    padding: 50px 30px 80px 30px;
    z-index: 2;
    background-image: url('https://images.ctfassets.net/3dar4x4x74wk/6fYU7sWQ2p09OPGFWtosjo/c5a8968c36745995cf9ce205ff5bd6de/BG_purple-green-gradient.jpg');
    background-size: cover;
    background-position: center;

    @media (min-width: $md) {
      padding: 75px 0 100px 0;
    }

    video {
      margin: -75px 0 25px 0;
    }

    h2 {
      font-weight: 800;
      font-size: 22px;
    }

    h3 {
      font-weight: 800;
      font-size: 20px;
      margin-top: 50px;
      margin-bottom: 50px;
      letter-spacing: .03;

      @media (min-width: $md) {
        margin-bottom: 100px;
      }
    }

    .packages {
      .package {
        width: 100%;

        @media (min-width: $md) {
          width: 47.5%;
          padding: 0;
        }

        &:first-of-type {
          @media (max-width: $md) {
            margin-bottom: 100px;
          }
        }

        img {
          height: auto;
          width: 65%;
          margin-bottom: 15px;

          @media (min-width: $md) {
            height: 125px;
            width: auto;
          }
        }

        h4 {
          font-weight: 900;
        }

        p {
          font-size: 16px;
          font-weight: 500;
          margin-top: 15px;
          margin-bottom: 15px;

          @media (min-width: $md) {
            width: 80%;
          }
        }
      }
    }
  }

  .package-overviews {
    padding: 0 30px 50px 30px;
    
    h2 {
      position: relative;
      z-index: 2;
      font-size: 32px;
      line-height: 32px;
      color: #633494;
    }

    .packages {
      position: relative;
      z-index: 2;
      padding-top: 25px;

      @media (min-width: $md) {
        padding-top: 50px;
      }
      .package {
        width: 100%;
        padding: 15px 0;

        @media (min-width: $md) {
          width: 30%;
          padding: 0;
        }

        img {
          z-index: 2;
          width: 100px;
          height: 100px;
          @media (min-width: $sm) {
            width: 40%;
            height: 40%; 
          }
        }

        .subtitle {
          padding: 20px 0;
          p {
            font-size: 14px;
            line-height: 14px;
            padding-right: 5px;
          }

          div {
            flex: 1;
            height: 7px;
          }
        }

        h1 {
          font-size: 48px;
          line-height: 38px;
        }

        .price {
          font-size: 40px;
          line-height: 32px;

          sup {
            font-size: 28px;
          }
        }
      }
    }

    &::before {
      transform: skewY(3deg) translateX(-30px) translateY(-35px);
      // display: block;
      position: absolute;
      display: block;
      width: 100vw;
      height: 100px;
      content: "";
      background: white;
      z-index: 1;
      transition: .25s;

      @media (min-width: 1400px) {
        transform: skewY(2deg) translateX(-30px) translateY(-35px);
      }
    }
  }

  .team-building-form {
    padding: 0 30px;

    .disclaimer {
      padding: 50px 0;
      font-size: 12px;
    }
  }

  .bottom-image {
    background-image: url('https://images.ctfassets.net/3dar4x4x74wk/7u7N2mcydqbV6Hi0e0rZBO/a0b12c18e7ade7550c06efb5c127ca97/team-building-footer-image.png');
    background-size: cover;
    background-position: center;
    width: 100%;
    height: 200px;

    @media(min-width: $sm) {
      height: 400px;
    }
  }
}

</style>